import React from 'react'

const Loader = () => {
    return (
        <div id="loading">
            <div id="loading-center">
            </div>
        </div>
    )
}

export default Loader